import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { scrollToTop } from "../lib/utils";

interface NavigationItem {
  name: string;
  href: string;
}

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const location = useLocation();

  const navigation: NavigationItem[] = [
    { name: "ACCUEIL", href: "/" },
    { name: "QUI SOMMES-NOUS", href: "/aboutus" },
    { name: "FIBRE URBAINE", href: "/fiber" },
    { name: "CONTACT", href: "/contact" },
  ];

  const isActive = (href: string): boolean => {
    return location.pathname === href;
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link
            to="/"
            onClick={() => scrollToTop()}
            className="flex items-center space-x-3 hover:opacity-90 transition-opacity"
          >
            {/* <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
              <div className="w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center">
                <div className="w-6 h-0.5 bg-white rounded-full"></div>
                <div className="w-4 h-0.5 bg-amber-400 rounded-full ml-0.5"></div>
              </div>
            </div> */}

            <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
              <img
                src={`${process.env.PUBLIC_URL}/pave-mark-logo.png`}
                alt="Parking lot with markings"
                className="w-12 h-12 object-cover text-center mx-auto"
              />
            </div>

            <div>
              <h1 className="text-xl font-bold text-gray-900">PaveMark</h1>
              <p className="text-sm text-gray-600 -mt-1">Marquage au sol</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item: NavigationItem) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                  isActive(item.href)
                    ? "text-amber-600 border-b-2 border-amber-600 pb-1"
                    : "text-gray-700"
                }`}
                onClick={() => scrollToTop()}
              >
                {item.name}
              </Link>
            ))}
            {/* <Button
              asChild
              className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white shadow-lg hover:shadow-xl transition-all"
            >
              <Link
                to="/contact"
                onClick={() => scrollToTop()}
              >
                Soumission
              </Link>
            </Button> */}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-gray-900"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-100 bg-white">
          <div className="px-4 py-4 space-y-3">
            {navigation.map((item: NavigationItem) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => {
                  scrollToTop()
                  return setIsMenuOpen(false);
                }}
                className={`block text-base font-medium transition-colors hover:text-amber-600 ${
                  isActive(item.href) ? "text-amber-600" : "text-gray-700"
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Button
              asChild
              className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white"
            >
              <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                Soumission
              </Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
